export default __webpack_public_path__ + "static/media/helpline-person.934cdbca.png";